import { render } from "./Exchange.vue?vue&type=template&id=21681239&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=21681239&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21681239"]])

export default __exports__